import { signInWithPopup } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { MakyMascot } from "@/components/brand/MakyMark";
import { Button } from "@/components/ui";
import { track } from "@/lib/analytics";
import { auth, googleProvider } from "@/lib/firebase/config";

export default function LoginPage() {
  const navigate = useNavigate();

  async function handleLogin() {
    try {
      await signInWithPopup(auth, googleProvider);
      // 캠페인이 데려온 방문이 계정이 되는 지점. 이메일·uid 는 넘기지 않는다.
      track("login", { method: "google" });
      navigate("/", { replace: true });
    } catch {
      toast.error("로그인에 실패했어요. 다시 시도해 주세요.");
    }
  }

  return (
    <main className="mx-auto flex min-h-dvh max-w-md flex-col justify-center gap-8 p-6">
      {/* 처음 보는 화면이라 한 번에 다 뜨는 대신 위에서 아래로 들어온다 —
          마스코트, 약속, 설명, 버튼 순서가 읽는 순서다. `pop-in` 은 fill:both 라
          차례가 오기 전에는 보이지 않는다. */}
      <MakyMascot size={132} className="animate-pop-in motion-reduce:animate-none" />
      <div>
        <h1
          className="animate-pop-in text-display-2 font-bold text-label-normal motion-reduce:animate-none"
          style={{ animationDelay: "60ms" }}
        >
          막냉이
        </h1>
        <p
          className="mt-1 animate-pop-in text-heading-2 font-semibold text-primary motion-reduce:animate-none"
          style={{ animationDelay: "120ms" }}
        >
          회식은 제가 챙길게요.
        </p>
        <p
          className="mt-3 animate-pop-in text-body-1 text-label-alternative motion-reduce:animate-none"
          style={{ animationDelay: "180ms" }}
        >
          주문 걷기도, 건배사도 제 일이에요. 로그인만 하면 시작할 수 있어요.
        </p>
      </div>
      {/* 화면에 버튼이 하나뿐이다. 엄지가 닿는 폭으로 둔다.
          등장 애니메이션은 감싼 div 가 진다 — `fill: both` 애니메이션이 버튼에
          직접 붙으면 최종 transform 이 남아서 누를 때의 `scale(0.97)` 을 덮는다. */}
      <div className="animate-pop-in motion-reduce:animate-none" style={{ animationDelay: "240ms" }}>
        <Button size="large" fullWidth onClick={handleLogin}>
          구글로 로그인하기
        </Button>
      </div>
    </main>
  );
}
